

import { Stack, Typography } from '@mui/material';
import { BasicSkeleton } from 'components/SkeletonLoaders';
import Card from './Card';

const EmptyContainer = () => (
  <Typography
    variant='body2'
    color='primary.gray50'
    sx={{ textAlign: 'center', marginTop: 2 }}>
    No record found.
  </Typography>
);

const CareList = ({
  careCenters,
  enrolledIds = [],
  onClickCareCenter,
  isListDetailedCareCenterLoading = false,
  searchTerm = '',
  searchAttempted = false,
  ...rest
}) => (
  <>
    {
      isListDetailedCareCenterLoading
        ? (
          <BasicSkeleton
            height={70}
            width='100%'
          />
        )
        : (careCenters && careCenters.length > 0)
          ? (
            <Stack
              spacing='8px'
              {...rest}>
              {careCenters.map(({ id, name, address, redirectUrl }) => {
                const isEnrolled = enrolledIds.includes(id);
                return (
                  <Card
                    key={id}
                    name={name}
                    address={address}
                    isEnrolled={isEnrolled}
                    onClick={isEnrolled ? undefined : () => onClickCareCenter(redirectUrl)}
                  />
                );
              })}
            </Stack>
          )
          : (searchAttempted && searchTerm && searchTerm.length > 0)
            ? <EmptyContainer />
            : null
    }
  </>
);

export default CareList;
